import * as z from "zod/v4";

export const hideInvisibleRateNameCharsAllowed = {
  name: "hideInvisibleRateNameCharsAllowed" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ allowed: z.boolean(), reason: z.string().optional() }),
};
